// OJO: `embbeded` está mal escrito a propósito. Es el valor exacto que espera
// Conekta (con doble "b"), documentado así en
// https://developers.conekta.com/docs/3ds2-direct-api
//
// Con cualquier otro valor el componente de Conekta NO corre en modo embebido y
// nunca emite el `postMessage` de resultado, así que el modal 3DS se queda abierto
// para siempre sin éxito ni error.
const EMBEDDED_SOURCE = 'embbeded';

export const createEmbeddedConektaUrl = url => {
  return `${url}${url.includes('?') ? '&' : '?'}source=${EMBEDDED_SOURCE}`;
};
